<template>
    <div class="form-group">
        <label :for="internalId">{{ internalLabel }}</label>
        <input
            type="text"
            :id="internalId"
            :name="name"
            class="form-control"
            :class="{
                'is-invalid' : error,
                [classe]:classe
            }"
            v-bind:value="value"
            @input="$emit('input', $event.target.value)"
            :placeholder="internalLabel"
            :autofocus="autofocus"
            :autocomplete="classe == 'datepicker' ? 'off' : 'on'"
            ref="input"
            @blur="$emit('input-blur')"
            >

        <div class="invalid-feedback" v-if="error">
            {{ error }}
        </div>
    </div>
</template>

<script>
import datepicker from 'bootstrap-datepicker';

export default {
    name: "TextInput",
    props: {
        name: { type: String, required: true },
        id: { type: String|null|undefined, default: '', required: false },
        label: { type: String, default: '', required: false },
        error: { type: String, default: '', required: false },
        value: { type: String, default: '', required: false },
        autofocus: { type: Boolean, default: false, required: false },
        classe: { type: String, default: '', required: false },
        min: { type:String, default: '', required: false},
        max: { type:String, default: '', required: false},
        showDatesTooltips: { type: Object, default: () => ({}), required: false},
    },
    data() {
        return {
            internalId: this.$props.id.length ? this.$props.id : this.$props.name,
            internalLabel: this.$props.label.length ? this.$props.label : this.$props.name,
        };
    },
    watch: {
        label(newVal) {
            this.internalLabel = newVal.length ? newVal : this.name;
        }
    },
    mounted() {
        const self = this;

        if (this.classe === 'datepicker') {
            $(this.$refs.input).datepicker({
                format: 'dd/mm/yyyy',
                autoclose: true,
                calendarWeeks: true,
                weekStart: 1,
                startDate: this.min ? this.min : null,
                endDate: this.max ? this.max : null,
                beforeShowDay: function(date) {
                    const formattedDate = date.toLocaleString('nl-BE', {day: '2-digit', month: '2-digit', year: 'numeric'})
                    const dates = Object.keys(self.showDatesTooltips);

                    if (dates.includes(formattedDate)) {

                        return {classes: 'bg-info text-light', tooltip: self.showDatesTooltips[formattedDate]};
                    }

                    return;
                },
            }).on('changeDate', (e) => {
                this.$emit('input', e.format('dd/mm/yyyy'));
            });
        }
    },
    beforeDestroy() {
        if (this.classe === 'datepicker') {
            $(this.$refs.input).datepicker('destroy');
        }
    }
}
</script>